export default "__VITE_ASSET__DMgA9RZ6__"